// Code points after boundary trimming, matching the authentication DvaFileNumberValue contract. CU-14ygtkj8p14
export const DVA_FILE_NUMBER_MAX_LENGTH = 32;

export const DVA_FILE_NUMBER_TOO_LONG_MESSAGE = `DVA file number must be ${DVA_FILE_NUMBER_MAX_LENGTH} characters or fewer.`;

export const toCanonicalDva = (value: string | null | undefined): string | null => {
	const trimmed = (value ?? '').trim();
	return trimmed === '' ? null : trimmed;
};

export const dvaFileNumberWithinLimit = (raw: string): boolean =>
	Array.from(raw.trim()).length <= DVA_FILE_NUMBER_MAX_LENGTH;
